import type { TherapyTimeInterval } from '@lmt/signal-viewer-ui';
import { apiClient } from './api-client';

/** Calls endpoint to generate PDF report with selected therapy day. */
export const postRenderReport = async (
  therapyDayIndex: number,
  therapyTimeInterval: TherapyTimeInterval,
) => {
  const { data } = await apiClient.post(
    '/render-report',
    {
      index: therapyDayIndex,
      reportTherapyTimeInterval: therapyTimeInterval,
    },
    { responseType: 'blob' },
  );
  return data;
};
